import type { ReactNode } from "react";
import { SectionTitle } from "@/src/common/components/ui/section-title";
import { clsx } from "@/src/common/utils/clsx";

interface SidebarSectionProps {
	title?: ReactNode;
	children: ReactNode;
	className?: string;
}

export function SidebarSection({ title, children, className }: SidebarSectionProps) {
	return (
		<section className={clsx("flex flex-col gap-1", className)}>
			{title ? <SectionTitle className="mb-1 mt-1">{title}</SectionTitle> : null}
			{children}
		</section>
	);
}
